import * as React from 'react';
import {SurveyModel} from '../types/SurveyModel';
import {Construct} from '../types/Construct';
import {Question} from '../types/Question';
import {QuestionChoice} from '../types/QuestionChoice';
import CallbackHelpers from '../helpers/CallbackHelpers';
import {EmployeeSelectOptions} from '../types/EmployeeSelectOptions';

export interface SurveyModelCacheProps {
  getSurveyModels: (languageCode: string) => SurveyModel[];
  getConstructs: (surveyModelId: string, languageCode: string) => Construct[];
  getConstructsAsync: (surveyModelId: string, languageCode: string) => Promise<Construct[]>;
  findConstructTranslationByCodeAsync: (surveyModelId: string,
                                        constructCode: string,
                                        languageCode: string) => Promise<Construct>;
  getConstructQuestions: (surveyModelId: string, constructCode: string, languageCode: string) => Question[];
  getAllQuestions: (surveyModelId: string, languageCode: string) => Question[];
  getAllChoices: (surveyModelId: string, languageCode: string) => QuestionChoice[];
  findConstructByCode: (surveyModelId: string,
                        constructCode: string,
                        languageCode: string) => Construct | undefined;
  findQuestionByCode: (surveyModelId: string,
                       questionCode: string,
                       languageCode: string) => Question | undefined;

  findQuestionByCodeAsync: (surveyModelId: string,
                            questionCode: string,
                            languageCode: string) => Promise<Question>;
  getQuestionChoices: (surveyModelId: string,
                       questionCode: string,
                       languageCode: string) => QuestionChoice[];
  getEmployeeSelectOptions: (surveyModelId: string,
                             questionCode: string,
                             languageCode: string) => EmployeeSelectOptions;
  clearCache: () => void;
  isLoaded: (languageCode: string) => boolean;
  isSurveyModelCacheProcessing: boolean;
}

export const SurveyModelCache = React.createContext<SurveyModelCacheProps>({
  getSurveyModels: CallbackHelpers.ThrowNotImplemented,
  getConstructs: CallbackHelpers.ThrowNotImplemented,
  getConstructsAsync: CallbackHelpers.ThrowNotImplemented,
  findConstructTranslationByCodeAsync: CallbackHelpers.ThrowNotImplemented,
  getConstructQuestions: CallbackHelpers.ThrowNotImplemented,
  getAllQuestions: CallbackHelpers.ThrowNotImplemented,
  getAllChoices: CallbackHelpers.ThrowNotImplemented,
  findConstructByCode: CallbackHelpers.ThrowNotImplemented,
  findQuestionByCode: CallbackHelpers.ThrowNotImplemented,
  findQuestionByCodeAsync: CallbackHelpers.ThrowNotImplemented,
  getQuestionChoices: CallbackHelpers.ThrowNotImplemented,
  getEmployeeSelectOptions: CallbackHelpers.ThrowNotImplemented,
  clearCache: CallbackHelpers.ThrowNotImplemented,
  isLoaded: CallbackHelpers.ThrowNotImplemented,
  isSurveyModelCacheProcessing: false
});
